window.addEventListener('load', function() {
            //Footer Year
            var currentYear = new Date().getFullYear();
            $(".footer-block__details-content p strong").html(currentYear); 

            // Popup read label
            $('a.read-lbl').on('click', function(e){
                e.preventDefault();
                $('body').addClass("pop");
                $( ".label-pop" ).show();
            });

            $(".close-pop").click(function(){
                $( ".label-pop" ).hide();
                $('body').removeClass("pop");
            });

            /**$('.full-zoom-no')
                .wrap('<span style="display:inline-block"></span>')
                .css('display', 'block')
                .parent()
                .zoom({
                url: $(this).find('img').attr('data-full-src')
            });**/

            $('.reels').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 5000,
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });

            $('.reco-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: false,
            draggable: false
            });
            $('.reco-nav').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            focusOnSelect: true,
            arrows: false,
            dots: false,
            infinite: true,
            centerMode: true, 
            centerPadding: '0px',
            asNavFor: '.reco-slider'
            });

            

            $('.opt-slider').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                responsive: [
                    {
                    breakpoint: 1025,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                    breakpoint: 769,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            dots: false,
                            arrows: false,
                            infinite: false 
                        }
                    }
                ]
            });
            $('.sec02 ul').slick({
                    slidesToShow:5,
                    slidesToScroll:1,
                    infinite:true,
                    autoplay:true,
                    arrows:false,
                    autoplaySpeed:0,
                    speed:11000,
                    cssEase:"linear"
                });

            $(".acc h3").click(function(){
                $(this).parent(".acc").toggleClass("show-acc");
            });

            $(window).resize(function(){
                if($(window).width() < 768) {
                    mobileOnlySlider();
                } 
            });

            if($(window).width() < 768) {
                mobileOnlySlider();
            } 
    
            function mobileOnlySlider() {

                $('.ing-con').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                    infinite: false 
                });

                $('.test-slider').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    autoplaySpeed: 0,
                    dots: false,
                    arrows: false,
                    infinite: true 
                });

            }
            
    });